<template>
  <ComparisonDesktop v-if="isDesktop" :animation-enabled="animationEnabled" />
  <ComparisonMobile v-else />
</template>

<script>
import { mapGetters } from 'vuex';
import ComparisonDesktop from './comparison-desktop';
import ComparisonMobile from './comparison-mobile';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
  },
  components: { ComparisonMobile, ComparisonDesktop },
  computed: {
    ...mapGetters('layoutModule', ['isDesktop']),
  }
};
</script>
